import { render, staticRenderFns } from "./BatchDialog.vue?vue&type=template&id=95fd13c2&scoped=true&"
import script from "./BatchDialog.vue?vue&type=script&lang=js&"
export * from "./BatchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95fd13c2",
  null
  
)

export default component.exports